import React from "react";
import "./ServicesAuditApproach.css";
import { useLocation } from "react-router-dom";

// ================= ENGLISH DATA
import * as EN from "../../../Data/ServicesAuditApproachData";
// ================= FRENCH DATA
import * as FR from "../../../Data/French/ServicesAuditApproachDataFR";

export default function ServicesAuditApproach({ currentLanguage = "en" }) {
  const location = useLocation();
  const path = location.pathname;
  const isFrench = currentLanguage === "fr";

  // ================= MAP PATHS TO KEYS
  const pathMap = {
    "/services/auditandassurance/financialstatementaudit": "fsa",
    "/services/auditandassurance/ifrsadvisoryservice": "ifrs",
    "/services/auditandassurance/otherassuranceservice": "oas",
    "/services/auditandassurance/internalcontrolframework": "icf",
    "/services/advisory/dealadvisory": "dealAdvisory",
    "/services/advisory/restructuring": "restructuring",
    "/services/advisory/duediligence": "dueDiligence",
    "/services/advisory/forensicservices": "forensic",
    "/services/advisory/riskadvisory": "riskAdvisory",
    "/services/advisory/technologyadvisoryservice": "techAdvisory",
    "/services/advisory/valuations": "valuations",
    "/services/taxation/corporatetax": "corporateTax",
    "/services/taxation/mergerandacquisition": "mergerAcquisition",
    "/services/taxation/transferpricing": "transferPricing",
    "/services/taxation/valueaddedtax": "valueAddedTax",
    "/services/taxation/internationaltax": "internationalTax",
    "/services/taxation/excisetax": "exciseTax",
    "/services/taxation/taxrestructuring": "taxRestructuring",
    "/services/taxation/economicsubstanceregulations": "economicSubstanceRegulations",
    "/services/businessserviceoutsourcing/financeandaccounting": "financeAndAccounting",
    "/services/businessserviceoutsourcing/corporateadvisoryservices": "corporateAdvisoryServices",
    "/services/businessserviceoutsourcing/expensesclaimmanagement": "expensesClaimManagement",
    "/services/businessserviceoutsourcing/payrollhrservices": "payrollHrServices",
    "/services/businessserviceoutsourcing/secondment": "secondment",
    "/services/businessserviceoutsourcing/treasuryservice": "treasuryService",
    "/services/strategies/marketresearch": "marketResearch",
    "/services/strategies/businessconsulting": "businessConsulting",
    "/services/corporateservices/entitysetup": "entitySetup",
    "/services/corporateservices/outsourcedfinanceregulatorycompliance": "outsourcedFinanceRegulatoryCompliance",
    "/services/corporateservices/companysecertarial": "companySecretarial",
  };

  const key = pathMap[path] || "auditApproach"; // default key

  // ================= LANGUAGE DATA OBJECTS
  const languageData = isFrench
    ? {
        heading: FR[`${key}Heading`] || FR.auditApproachHeading,
        steps: FR[`${key}Steps`] || FR.auditApproachSteps,
      }
    : {
        heading: EN[`${key}Heading`] || EN.auditApproachHeading,
        steps: EN[`${key}Steps`] || EN.auditApproachSteps,
      };

  const { heading, steps } = languageData;

  return (
    <div className="services-audit-main section" style={{ backgroundImage: "url('/assets/images/services-audit-main-BG.png')" }}>
      <div className="services-audit-content">

        {/* LEFT SIDE */}
        <div className="d-flex justify-content-center align-items-center">
          <div className="services-audit-left">
            <div className="d-flex align-items-center justify-content-start mb-2">
              <div className="services-line me-3"></div>
              <p className="service-subtitle mb-0">{heading.subtitle}</p>
            </div>

            <h2 className="service-title width-service mb-5">
              {heading.title.length > 30 ? (
                <>
                  {heading.title.slice(0, 30)}
                  <br />
                  {heading.title.slice(30)}
                </>
              ) : (
                heading.title
              )}
            </h2>

            <p className="service-audit-desc">{heading.description1}</p>
            <p className="service-audit-desc">{heading.description2}</p>
          </div>
        </div>

        {/* RIGHT SIDE BOXES */}
        <div className="services-audit-right">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`audit-step-box ${index % 2 === 0 ? "box-down" : ""}`}
            >
              <div className="audit-icon">
                <img src={step.icon} alt="icon" />
              </div>
              <h5 className="audit-step-title">{step.title}</h5>
              <p className="audit-step-text">{step.text}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
